import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Roles from '../../components/blocks/Roles';
import { setRolesRole, getRoles } from '../../store/actions/roles';

function hasNoRoles(role) {
  return role && !role.retailers.length && !role.suppliers.length;
}

function RoleContainer(props) {
  const { getRoles } = props;

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  if (props.isSuperAdmin && hasNoRoles(props.roles)) {
    return null;
  }

  return <Roles {...props} />;
}

const mapStateToProps = (state) => {
  const { user } = state.role;

  if (!user) {
    return {};
  }

  const { retailers, suppliers } = user;

  return {
    isSuperAdmin: user.is_super_admin,
    roles: {
      retailers,
      suppliers,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  setRole: (id, role) => dispatch(setRolesRole(id, role)),
  getRoles: () => dispatch(getRoles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleContainer);

RoleContainer.defaultProps = {
  roles: undefined,
  suppliersMenu: false,
};

RoleContainer.propTypes = {
  setRole: PropTypes.func.isRequired,
  roles: PropTypes.shape({
    retailers: PropTypes.array,
    suppliers: PropTypes.array,
  }),
  getRoles: PropTypes.func.isRequired,
  suppliersMenu: PropTypes.bool,
};
